import React from 'react'

const ResultItem = ({ text, value }) => {
  return (
    <div>
        <p>{text}</p>
        <p>{value}</p>
    </div>
  )
}

export default ResultItem